import React from "react";

import ServiceView from "../../components/ServiceView";
import ServiceLarge0 from "../../assets/service_large_0.jpg";
import ServiceLarge1 from "../../assets/service_large_1.jpg";
import ServiceLarge2 from "../../assets/service_large_2.jpg";
import styles from "./styles.module.scss";

const Services: React.FC = () => {
  const residentialSL = [
    "Driveways",
    "Decorative Areas",
    "Exposed Aggregate Concrete",
    "Bush Hammered Concrete",
    "House Floors",
    "Pool Areas",
    "Residential Crossings",
  ];
  const commercialSL = [
    "RibRaft Floors",
    "Commercial Floors",
    "Parking Areas",
    "Spec floors",
    "Commercial Crossings",
    "Footpathing contracts",
  ];
  const ruralSL = [
    "Cow Sheds",
    "Races",
    "Stone Traps",
    "Herd Homes",
    "Feed Pads",
    "Feed Bins",
    "Underpasses",
    "Sumps",
  ];

  return (
    <div className={styles.container}>
      <div className={styles.pagetitle}>
        <h1>Services</h1>
        <p>Here's what we can do for you</p>
      </div>
      <ServiceView
        title="Residential"
        uri={ServiceLarge2}
        serviceList={residentialSL}
      />
      <ServiceView
        title="Commercial"
        uri={ServiceLarge1}
        serviceList={commercialSL}
      />
      <ServiceView title="Rural" uri={ServiceLarge0} serviceList={ruralSL} />
    </div>
  );
};

export default Services;
